import { useCallback } from 'react';
import { useGlobalStateStore, useGlobalStateStoreManager } from './GlobalStateStoreProvider';

export { useGetDeviceDetailsInStateStore } from '../app/GlobalAppStateStore/hook';

export const useGetGlobalStateStoreState = () => {
  return {
    getGlobalStateStoreState: useGlobalStateStore().getState,
  };
};

export const useGetGlobalStateStoreStateByInstanceId = () => {
  const manager = useGlobalStateStoreManager();
  return useCallback((instanceId?: string) => manager.getStore(instanceId).getState(), [manager]);
};
